import axios from "axios";

export default {
  methods: {
    /**
     * Recupera os endereços em formato de listagem paginada
     * @param {String} params
     * @return {
     * {
     *    "conteudo": [
     *      {
     *        "bairro": "string",
     *        "chaveReferencia": "string",
     *        "cidade": "string",
     *        "cnpj": "string",
     *        "tipo": "string",
     *        "uf": "string"
     *      }
     *    ],
     *    "numeroPagina": 0,
     *    "tamanhoPagina": 0,
     *    "totalElementos": 0,
     *    "totalPaginas": 0
     *  }
     * }
     */
    getTabelaEndereco(params) {
      return axios.get(
        this.CriarUrl({
          resource: `endereco`,
          params
        })
      );
    },
    /**
     * Recupera os detalhes de um endereço específico
     * @param {Number} idArquivo
     * @param {Number} nrSeq
     * @return {
     *   {
     *    "bairro": "string",
     *    "cep": "string",
     *    "chaveReferencia": "string",
     *    "cidade": "string",
     *    "cnes": "string",
     *    "cnpj": "string",
     *    "dddFax": "string",
     *    "dddTelefonePrincipal": "string",
     *    "dddTelefoneSecundario": "string",
     *    "dddWhatsapp": "string",
     *    "email": "string",
     *    "fax": "string",
     *    "filial": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "gruposServico": [
     *      {
     *        "codigo": 0,
     *        "nome": "string"
     *      }
     *    ],
     *    "logradouro": "string",
     *    "numero": "string",
     *    "telefonePrincipal": "string",
     *    "telefoneSecundario": "string",
     *    "uf": "string",
     *    "whatsapp": "string"
     *  }
     * }
     */
    getDetalheEndereco(idArquivo, nrSeq) {
      return axios.get(
        this.CriarUrl({
          resource: `endereco/${idArquivo}/${nrSeq}`
        })
      );
    },
    /**
     * Retorna todas as cidades
     * @return {
     * [
     *    {
     *      "chave": "string",
     *      "valor": "string"
     *    }
     *  ]
     * }
     */
    getCidades() {
      return axios.get(
        this.CriarUrl({
          resource: `endereco/municipios`
        })
      );
    },
    /**
     * Retorna todos os tipos de endereço
     * @return {
     * [
     *    {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    }
     *  ]
     * }
     */
    getTipoEndereco() {
      return axios.get(
        this.CriarUrl({
          resource: `endereco/tipoEndereco`
        })
      );
    }
  }
};
